import { useEffect } from 'react'

const SITE_NAME = 'TxMCCS'

export function usePageTitle(title: string) {
  useEffect(() => {
    document.title = `${title} | ${SITE_NAME}`
  }, [title])
}
